import './index.css';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { reloadOnceForStaleChunk } from '@/app/staleChunkReload';

import { Routes } from './app/routes/react-router-lazy';

// Vite reports here when a chunk's preload fails, which happens before the
// router even attempts the import. This covers startup; the router covers
// navigation. See `staleChunkReload`.
window.addEventListener('vite:preloadError', () => {
  reloadOnceForStaleChunk();
});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
);
